// src/styles/variables.js
export const colors = {
	primary: '#1b1c1d',
	secondary: '#00c471',
	tertiary: '#3e4042',
	lightGray: '#f2f4f6',
	textGray: '#333333',
	white: '#ffffff',
	javaColor: '#007396',
	javaAdvancedColor: '#5d4037',
	cColor: '#659ad2',
	reactColor: '#61dafb',
	typescriptColor: '#3178c6',
	dbColor: '#f29111',
	aiColor: '#16a085'
  };
  
  export const breakpoints = {
	mobile: '768px',
	tablet: '1024px',
	desktop: '1200px'
  };